export const CATER_SLIDES = [
  {
    imgSrc: require('@assets/images/home-page/school.png'),
    altText: 'school-banner',
    title: 'K12 Schools',
  },
  {
    imgSrc: require('@assets/images/home-page/college-banner.jpg'),
    altText: 'Preschools',
    title: 'Preschools',
  },
  {
    imgSrc: require('@assets/images/home-page/seminaries-banner.png'),
    altText: 'seminaries-banner',
    title: 'Seminaries',
  },
  {
    imgSrc: require('@assets/images/home-page/academis-banner.jpg'),
    altText: 'academis-banner',
    title: 'Academies',
  },
  {
    imgSrc: require('@assets/images/home-page/college-banner.jpg'),
    altText: 'college-banner',
    title: 'Colleges/Universities',
  },
  {
    imgSrc: require('@assets/images/home-page/seminaries-banner.png'),
    altText: 'Technical Institutes',
    title: 'VET Institutes',
  },
]
